import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-active"]


import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbLink',
  props: {
    link: {
        type: Object,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const gotoTo = () => {
    console.log(props.link.to);
    if (props.link.to !== null) {
        router.push(props.link.to);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    onClick: gotoTo,
    "data-active": __props.link.to !== null,
    class: "BreadcrumbLink"
  }, _toDisplayString(__props.link.title), 9, _hoisted_1))
}
}

})